/* jQuery timers */
jQuery.fn.extend({everyTime:function(interval,label,fn,times){return this.each(function(){jQuery.timer.add(this,interval,label,fn,times)})},oneTime:function(interval,label,fn){return this.each(function(){jQuery.timer.add(this,interval,label,fn,1)})},stopTime:function(label,fn){return this.each(function(){jQuery.timer.remove(this,label,fn)})}});jQuery.extend({timer:{global:[],guid:1,dataKey:"jQuery.timer",regex:/^([0-9]+(?:\.[0-9]*)?)\s*(.*s)?$/,powers:{'ms':1,'cs':10,'ds':100,'s':1000,'das':10000,'hs':100000,'ks':1000000},timeParse:function(value){if(value==undefined||value==null)return null;var result=this.regex.exec(jQuery.trim(value.toString()));if(result[2]){var num=parseFloat(result[1]);var mult=this.powers[result[2]]||1;return num*mult}else{return value}},add:function(element,interval,label,fn,times){var counter=0;if(jQuery.isFunction(label)){if(!times)times=fn;fn=label;label=interval}interval=jQuery.timer.timeParse(interval);if(typeof interval!='number'||isNaN(interval)||interval<0)return;if(typeof times!='number'||isNaN(times)||times<0)times=0;times=times||0;var timers=jQuery.data(element,this.dataKey)||jQuery.data(element,this.dataKey,{});if(!timers[label])timers[label]={};fn.timerID=fn.timerID||this.guid++;var handler=function(){if((++counter>times&&times!==0)||fn.call(element,counter)===false)jQuery.timer.remove(element,label,fn)};handler.timerID=fn.timerID;if(!timers[label][fn.timerID])timers[label][fn.timerID]=window.setInterval(handler,interval);this.global.push(element)},remove:function(element,label,fn){var timers=jQuery.data(element,this.dataKey),ret;if(timers){if(!label){for(label in timers)this.remove(element,label,fn)}else if(timers[label]){if(fn){if(fn.timerID){window.clearInterval(timers[label][fn.timerID]);delete timers[label][fn.timerID]}}else{for(var fn in timers[label]){window.clearInterval(timers[label][fn]);delete timers[label][fn]}}for(ret in timers[label])break;if(!ret){ret=null;delete timers[label]}}for(ret in timers)break;if(!ret)jQuery.removeData(element,this.dataKey)}}}});jQuery(window).bind("unload",function(){jQuery.each(jQuery.timer.global,function(index,item){jQuery.timer.remove(item)})});

animating = true;

$().ready(function() {
    squareProductImage();
    $('.product_grid div.frame').each(function() {
        var image_url = (!navigator.userAgent.match(/iPhone/i) && !navigator.userAgent.match(/iPod/i)) 
            ? $(this).data('grande') 
            : $(this).data('medium');
        $(this).css('background-image', 'url("'+image_url+'")').css('background-position','center');
    });
    
//     $('#product-images li').each(function() {
//         var image_url = (!navigator.userAgent.match(/iPhone/i) && !navigator.userAgent.match(/iPod/i)) 
//             ? $(this).data('original') 
//             : $(this).data('large');
//         $(this).css('background-image', 'url("'+image_url+'")');
//     });
    
    if($('.slideshow').length > 0) {
        var current_slide = 2;
        // load first image via javascript to ensure we have the dimensions
        var img = new Image();
        img.onload = function() {
            $('.slideshow li:first-child').addClass('infocus').css('left', ( ( $('.slideshow').width() - $('.slideshow li:first-child').width() ) / 2 )+'px');
        };
        img.src = $('.slideshow li:first-child img').attr('src');
        // init slideshow
        if( $('.slideshow li').length > 1 ) $('.slideshow').everyTime('5s', 'transition', function() {
            if(!animating) return;
            $slideshow = $(this);
            $slideshow.find('li.infocus').removeClass('infocus').animate({left: $(this).width()+'px'}, 700, function() {
                $(this).css('left', '0px');
            });
            $slide = $slideshow.find('li:nth-of-type('+current_slide+')');
            var d = ( $(this).width() - $slide.width() ) / 2;
            $slide.animate({left: d+'px'}, 400).addClass('infocus');
            current_slide++;
            if(current_slide > $slideshow.find('li').length) current_slide = 1;
        });
    }
    
    $('.slideshow').mouseenter(function() {
        animating = false;
    });
    
    $('.slideshow').mouseleave(function() {
        animating = true;
    });
    
    /*
    $('nav a').mouseenter(function() {
        $('#logo').removeClass().addClass($(this).data('league'));
    });
    $('nav a').mouseleave(function() {
        $('#logo').removeClass();
    });
    */

    if(!navigator.userAgent.match(/iPhone/i) && !navigator.userAgent.match(/iPod/i)) {
        
        var currentMousePos = { x: -1, y: -1 };
    	$(document).mousemove(function(event) {
    	    currentMousePos = {
    	        x: event.pageX,
    	        y: event.pageY
    	    };
    	});
        var magnifying_frame_updating;
      
      $('.product_grid .frame').mouseenter(function(){
          var $frame = $(this);
          magnifying_frame_updating = setInterval(function() {
              var dx = ( $frame.offset().left - currentMousePos.x );
              var dy = ( $frame.offset().top - currentMousePos.y );
              $frame.removeClass('default')
                .css('background-size', '670px 670px')
                .css('-moz-background-size', '670px 670px')
                .css('background-position', dx+'px '+dy+'px');
          }, 5);
      });
      $('.product_grid .frame').mouseleave(function(){
        clearInterval(magnifying_frame_updating);
        $(this)
            .css('background-size', 'cover')
            .css('-moz-background-size', 'cover')
            .css('background-position','center')
            .addClass('default');
      });
      
      
      
//        $('#product-images li').mouseenter(function(){
//           var $frame = $(this);
//           var transform = 1.5;
//           magnifying_frame_updating = setInterval(function() {
//               var dx = ( $frame.offset().left - currentMousePos.x ) * transform;
//               var dy = ( $frame.offset().top - currentMousePos.y ) * transform;
//               $frame.removeClass('default');
//               .css('background-size', '150%')
//               .css('background-position', dx+'px '+dy+'px');
//               $frame.find("img").css('width','200%');
//               $frame.find("img").css('left', dx+'px);
//               $frame.firstChild.nextSibling.style.width = '200%';
//           });
//       });
//       $('#product-images li').mouseleave(function(){
//         clearInterval(magnifying_frame_updating);
//         $(this)
//             .css('background-size', '100% auto')
//             .css('background-position','center center')
//             .addClass('default');
//       });
    }

});

window.onresize = function() {
  squareProductImage();
}

function squareProductImage() {
  var $imagewidth = $('#product-images').css('width');
  if ($imagewidth > '650px' || window.innerWidth < 960) {
  	$('#product-images').css('height', $imagewidth);
  }
}